import PropTypes from "prop-types";
import CustomSpan from "./CustomSpan";
import React from "react";
import arrowBackActive from "../assets/icons/arrow-back-active.svg";
import arrowBackNotActive from "../assets/icons/arrow-back-not-active.svg";

function StepBar(props) {
  const {stepBarItems} = props;
  const bars = stepBarItems.map((item, index) => {
    if (index === stepBarItems.length - 1) {
      return '';
    }
    let leftPosition;
    // First position bar
    if (index === 0) {
      leftPosition = `left-[100px]`;
    }
    // Position bar after the first time
    if (index > 0 && stepBarItems.length > 2) {
      leftPosition = `2xl:left-[${100 + (index * 220)}px] xl:left-[${100 + (index * 180)}px] md:left-[${100 + (index * 160)}px]`;
    }
    return (
      <div
        key={index}
        className={`absolute ${leftPosition} top-[19px] 2xl:w-[220px] xl:w-[180px] md:w-[160px] h-[2px] bg-[#D0D5DD] z-0`}
      ></div>
    );
  });
  const getArrowBackIcon = (item) => {
    if (item.isActive) {
      return arrowBackActive
    }
    if (item.notPassed) {
      return arrowBackNotActive;
    }
  };

  return (
    <div className="flex items-center absolute left-[35%] top-[40px]">
      {bars}
      {stepBarItems.map((item, index) => (
        <div key={index}
             className={`flex flex-col items-center gap-[4px] 2xl:w-[220px] xl:w-[200px] md:w-[180px] z-10`}>
          <div
            className={`flex items-center justify-center xl:w-[40px] xl:h-[40px] md:w-[36px] md:h-[36px] rounded-full relative ${item.notPassed ? 'bg-[#D0D5DD]' : ''} ${item.isActive || item.hasPassed ? 'bg-[#2E90FA]' : ''} ${item.isActive || item.hasPassed ? '2xl:border-[4px] xl:border-[3px] md:border-[2px] border-[#FFF]' : ''}`}
          >
            <CustomSpan text={(index + 1).toString()}
                        className={`text-[#FFF] text-center 2xl:text-[20px] xl:text-[18px] md:text-[16px] font-normal leading-7`}/>
          </div>
          <CustomSpan text={item.spanText}
                      className={`${item.isActive ? 'text-[#2E90FA]' : ''}  ${item.notPassed || item.hasPassed ? 'text-[#667085]' : ''} text-center 2xl:text-[16px] xl:text-[15px] md:text-[14px] font-normal '2xl:leading-7 xl:leading-6 md:leading-5'`}/>
          {item.isBack && (
            <img src={getArrowBackIcon(item)} alt="arrow back icon"
                 className="xl:w-[60px] xl:h-[40px] md:w-[54px] md:h-[35px]  absolute 2xl:right-[55px] xl:right-[45px] md:right-[40px] xl:-top-[18px] md:-top-[14px]"/>
          )}
        </div>
      ))}
    </div>
  );
}

StepBar.propTypes = {
  stepBarItems: PropTypes.arrayOf(
    PropTypes.shape({
      spanText: PropTypes.string.isRequired,
      isActive: PropTypes.bool,
      hasPassed: PropTypes.bool,
      notPassed: PropTypes.bool,
      isBack: PropTypes.bool
    })
  ).isRequired,
};

export default StepBar;
